export enum ActionTypes {
  fetchTransportation,
  fetchStates,
  fetchCounties,
  fetchPlaces
}